const deepClone = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return value;
  }
};

export const prepareObjectCopyForPage = (obj, targetPageId, options = {}) => {
  const {
    offsetX = 20,
    offsetY = 20,
    keepPosition = false,
    group = null,
    zIndex,
  } = options;

  return {
    page: Number(targetPageId),
    group,
    type: obj.type,
    name: `${obj.name || obj.type}-copy`,
    x: keepPosition ? obj.x : obj.x + offsetX,
    y: keepPosition ? obj.y : obj.y + offsetY,
    width: obj.width,
    height: obj.height,
    rotation: obj.rotation || 0,
    z_index: zIndex ?? obj.z_index ?? 0,
    opacity: obj.opacity ?? 1,
    visible: obj.visible !== false,
    locked: false,
    style_json: deepClone(obj.style_json || {}),
    data_json: deepClone(obj.data_json || {}),
    meta_json: deepClone(obj.meta_json || {}),
  };
};

export const preparePageCopyPayload = (page) => ({
  title: `${page.title || "Page"} Copy`,
  description: page.description || "",
  width: page.width || 1600,
  height: page.height || 900,
  background_color: page.background_color || "#ffffff",
  background_image: page.background_image || "",
  show_grid: page.show_grid !== false,
  grid_size: page.grid_size || 20,
  is_active: page.is_active !== false,
  is_published: false,
});